import { addLocaleData } from "react-intl"
import en from "react-intl/locale-data/en" // english
import es from "react-intl/locale-data/es" // spanish
import ru from "react-intl/locale-data/ru" // russian
import fr from "react-intl/locale-data/fr" // french
import de from "react-intl/locale-data/de" // german

addLocaleData([...en, ...es, ...ru, ...fr, ...de])
